import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import CarrierEnrollApiUrls from 'src/apiUrls/CarrierEnrollApiUrls'
import React from 'react'
import CarrierEnrollKeys from 'src/constants/locale/key/CarrierEnroll'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification,
    useFetchCustomLookup
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.CARRIER_ENROLL
  ])
  const translatedTextsObject = makeTranslatedTextsObject()
  const fetchCustomLookup = useFetchCustomLookup();

  function makeTranslatedTextsObject() {
    let carrierEnroll = translate(
      Namespace.CARRIER_ENROLL,
      CarrierEnrollKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: carrierEnroll
      }
    )
    let platformName = translate(
      Namespace.CARRIER_ENROLL,
      CarrierEnrollKeys.PLATFORM_NAME
    )
    let carrierPartyId = translate(
      Namespace.CARRIER_ENROLL,
      CarrierEnrollKeys.PARTY_ID
    )
    let otherPlatformCode = translate(
      Namespace.CARRIER_ENROLL,
      CarrierEnrollKeys.OTHER_PLATFORM_CODE
    )
    let excludes = translate(
      Namespace.CARRIER_ENROLL,
      CarrierEnrollKeys.EXCLUDES
    )

    return {
      carrierEnroll,
      tableTitle,
      platformName,
      carrierPartyId,
      otherPlatformCode,
      excludes
    }
  }

  const columns = [
    {
      field: "platformName",
      title: translatedTextsObject.platformName,
    },
    {
      field: "carrierPartyId",
      title: translatedTextsObject.carrierPartyId,
      type: "numeric",
      customLookup: () => {
        return fetchCustomLookup(
          constants.apiUrl.PartyApiUrls.GET,
          {},
          'content',
          'name',
          'id',
          (error) => {
            console.log(error)
          }
        )
      }
    },
    {
      field: "otherPlatformCode",
      title: translatedTextsObject.otherPlatformCode,
    },
    {
      field: "excludes",
      title: translatedTextsObject.excludes,
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: CarrierEnrollApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: CarrierEnrollApiUrls.EXPORT }}
              fetch={{ url: CarrierEnrollApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
